import { useEffect, useState } from 'react';
import {
    whiteMyOrder,
    activeWhiteMyOrder,
    whiteFavourite,
    activeWhiteFavourite,
    whiteCart,
    activeWhiteCart,
    whiteMarket,
    activeWhiteMarket,
} from '../../assets/svgs';
import styles from './style.module.css';
import { NavLink, useLocation } from 'react-router-dom';

export const TabBar = () => {

    const location = useLocation()
    const [visible, setVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    // handle scroll direction
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > lastScrollY) {
                // scrolling down → hide
                setVisible(false);
            } else {
                // scrolling up → show
                setVisible(true);
            }
            setLastScrollY(window.scrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    const items = [
        // { label: 'Profile', href: '/buyer-profile', icon: profile, activeIcon: activeProfile, extraActive: [] },
        // { label: 'Notifications', href: '/buyer-notification', icon: notification, activeIcon: activeNotification, extraActive: [] },
        { label: 'Market', href: '/marketPlace', icon: whiteMarket, activeIcon: activeWhiteMarket, extraActive: [] },
        { label: 'My Orders', href: '/buyer-orders', icon: whiteMyOrder, activeIcon: activeWhiteMyOrder, extraActive: ['/buyer-order'] },
        { label: 'Favourite', href: '/buyer-favourite', icon: whiteFavourite, activeIcon: activeWhiteFavourite, extraActive: [] },
        { label: 'Cart', href: '/buyer-cart', icon: whiteCart, activeIcon: activeWhiteCart, extraActive: ['/buyer-checkout'] },
        // { label: 'Review', href: '/buyer-review', icon: review, activeIcon: activeReview, extraActive: ['/buyer-rate'] },
        // { label: 'Settings', href: '/buyer-settings', icon: setting, activeIcon: activeSetting, extraActive: [] },
    ];

    if (!visible) {
        return null
    }

    return (
        <aside className={styles.tabBar}>
            <nav className={styles.tabBarNav}>

                {items.map((item) => {
                    const isActive =
                        location.pathname === item.href ||
                        item.extraActive.some((path) => location.pathname.startsWith(path));

                    return (
                        <NavLink key={item.href} to={item.href} className={styles.tabBarLink}>
                            <>
                                <img src={isActive ? item.activeIcon : item.icon} alt={item.label} />
                            </>
                        </NavLink>
                    );
                })}

            </nav>
        </aside>
    );
};
